import { hasElement } from 'src/lib/utils.js'

export function highlightLineage(nodeType, highlight, cy) {
    let classMap = {
        'datasets': ['dataset', 'datasetEdge'],
        'distributions': ['distribution', 'distributionEdge'],
        'paths': ['pathEdge']
    }
    cy.elements().forEach(element => {
        if (hasElement(element.classes(), classMap[nodeType])) {
            if (highlight) {
                element.removeClass('level2Unhighlight')
                element.addClass('level1Highlight')
            } else {
                element.removeClass('level1Highlight')
                element.addClass('level2Unhighlight')
            }
        }
    })
}

export function manageTableOpacity(lineageStatus) {
    if (lineageStatus.paths.dashed || lineageStatus.distributions.dashed) {
        for (const card of document.getElementsByClassName("htmlCard")) {
            card.style.opacity = 1
        }
    } else {
        for (const card of document.getElementsByClassName("htmlCard")) {
            card.style.opacity = 0.8
        }
    }
}

export function hideLineage(type, hide, cy) {
    let edgeMap = {
        'datasets': ['datasetEdge'],
        'distributions': ['distributionEdge'],
        'paths': ['pathEdge']
    }
    cy.elements().forEach(element => {
        if (hasElement(element.classes(), edgeMap[type])) {
            element.style({
                'display': hide ? 'none' : 'element'
            })
        }
    })
}
